import { HttpContextToken } from '@angular/common/http';

export const SIGNAGE_API = new HttpContextToken<boolean>(() => false);
